<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_i"></a><span class="bold"><span class="f1">FIGHTER PILOT</span>: FROM COLD WAR JETS TO <span class="f2">SPITFIRES</span></span></p>
<p class="half1">THE EXTRAORDINARY MEMOIRS OF A BATTLE OF BRITAIN MEMORIAL FLIGHT PILOT<a id="page_ii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?afe36c78